export { DepartmentList } from './DepartmentList';
